
<ng-template #patternsFill>
	<pattern-fills-toggle></pattern-fills-toggle>
</ng-template>
<kebab-menu
	label="{{'common.openMenu'|i18n}}"
	[menuItems]="menuItems"
	(menuClosed)="focusToggle($event)">
</kebab-menu>